import PropTypes from 'prop-types'
import Typography from '../Typography/index'
import { IoCloseSharp } from 'react-icons/io5'
import { FiPlusCircle } from 'react-icons/fi'
import { CgAttachment } from 'react-icons/cg'
import { RxLetterCaseCapitalize } from 'react-icons/rx'

const FeedbackPopup = ({ onClose, data, title, children }) => {
  return (
    <div className="p-4 w-96">
      <div className="bg-primary flex px-2 py-4 justify-between items-center rounded-t-lg">
        <div>
          <Typography variant="h4" className="text-white">
            {title}
          </Typography>
        </div>
        <div onClick={onClose} className="flex mr-2 gap-2 items-center">
          <IoCloseSharp className="text-white text-2xl" />
        </div>
      </div>
      <div className="bg-white p-4 rounded-b-lg">
        <div className="flex justify-between items-center">
          <Typography variant="h4" className="">
            To: <span className="text-primary ml-4">{data?.full_name}</span>
          </Typography>
          <div>
            <FiPlusCircle className="text-xl text-primary mr-2" />
          </div>
        </div>
        <div>
          <Typography>Subject</Typography>
          <textarea className="w-full h-24"></textarea>
        </div>
        <div className="flex items-center gap-8">
          <div>{children}</div>
          <div className="flex gap-1">
            <RxLetterCaseCapitalize className="text-gray-500" />
            <CgAttachment className="text-gray-500" />
          </div>
        </div>
      </div>
    </div>
  )
}

FeedbackPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default FeedbackPopup
